<app-dialog-wrapper
    heading="common.demand-feedback-dialog.title"
    description="common.demand-feedback-dialog.description"
    confirmLabel="common.general.confirm"
    cancelLabel="common.general.cancel"
    width="650px"
    (confirmed)="confirm()"
    (cancelled)="close()"
>
    <form class="flex flex-col gap-4" [formGroup]="formGroup">
        <sh-editor
            formControlName="comment"
            [placeholder]="'common.comments.placeholder' | translate"
            class="w-full"
        ></sh-editor>
        <sh-file-input
            formControlName="attachments"
            [maxFileSizeMB]="500"
            [multiple]="true"
            class="w-full"
        ></sh-file-input>
    </form>
</app-dialog-wrapper>
